export default __webpack_public_path__ + "static/media/telemarketinghelp-detailE.1421be36.png";